import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import './Auth.css';
import { buildAuthNavigationTarget, resolveReturnTo } from './returnTo';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = resolveReturnTo({ location, fallback: '/home' });

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent. Check your inbox.');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-layout">
        <div className="auth-visual">
          <span className="tag">Secure Access</span>
          <h1>Reset and get back in.</h1>
          <p>
            We’ll send a reset link to your email so you can sign back in and get to your collector or artist tools quickly.
          </p>
        </div>

        <form className="auth-box" onSubmit={handleReset}>
          <h1>Razzberry</h1>
          <h2>Reset Password</h2>
          <p className="auth-subtitle">We’ll email you a secure reset link in a moment.</p>

        {error && <p className="error">{error}</p>}
        {message && <p className="success">{message}</p>}

        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit">Email Reset Link</button>

          <p className="link" onClick={() => navigate(buildAuthNavigationTarget('/signin', returnTo), { replace: true })}>
            Back to Login
          </p>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
